<div class="dialog">
  <div class="row">
    <div class="col-md-6">
      <h2 class="dialog-header">{{ modalTitle | translate }}</h2>
    </div>
    <div class="col-md-6 align-right">
      <button
        type="button"
        class="btn btn-xs btn-success"
        (click)="addRoomType()"
        *ngIf="listMode && permissions.canCreate"
      >
        <i class="fa fa-plus"></i> {{ 'ADD_ROOM_TYPE' | translate }}
      </button>
      <button type="button" class="btn btn-xs" (click)="showRoomTypes()" *ngIf="detailMode">
        <i class="fa fa-angle-left"></i> {{ 'BACK' | translate }}
      </button>

      <span class="dialog-close" (click)="close()">
        <i class="fa fa-close"></i>
      </span>
    </div>
  </div>

  <div class="dialog-content">
    <div *ngIf="listMode">
      <div *ngIf="permissions.canList">
        <app-room-type-list
          [roomTypes]="roomTypes"
          [meta]="meta"
          [loadingRoomTypes]="loadingRoomTypes"
          [defaultLanguage]="defaultLanguage"
          (selectedRoomType)="onSelectedRoomType($event)"
        ></app-room-type-list>
      </div>
      <div *ngIf="!permissions.canList">INVALID ACCESS</div>
    </div>

    <div *ngIf="detailMode">
      <app-room-type-detail
        [roomType]="roomType"
        [mode]="mode"
        [defaultLanguage]="defaultLanguage"
        [additionalLanguages]="additionalLanguages"
        [isModal]="true"
        (savedRoomType)="onSavedRoomType($event)"
        (canceledRoomType)="onCanceledRoomType()"
      ></app-room-type-detail>
    </div>
  </div>
</div>
